import { Student } from "../../../../store/viewmodels/StudentViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import TaskResultSummary from "./TaskResultSummary";

interface PrintResultsProps {
    student?: Student,

}

function PrintResults(props: PrintResultsProps): JSX.Element {
    if (!props.student) return <></>;

    const answerSets = props.student?.results;
    const tasks: Task[] = props.student !== undefined ? props.student.task_access_list : [] as Task[];
    let taskElements = [];

    for (let i: number = 0; i < tasks.length; i++) {
        taskElements.push(<TaskResultSummary key={"taskResultSummary" + tasks[i].id} currentTask={tasks[i]} answerSets={answerSets} student={props.student} runningNumber={i} />)
    }

    return (
        <div className="p-6">
            <div className="flex border-b border-gray-200 pt-2 pb-2">
                <div className="flex">
                    <h1 className="text-2xl font-extrabold text-gray-900">{props.student?.identification}</h1>
                    <h1 className="ml-4 text-2xl text-gray-500">{props.student?.username}</h1>
                </div>
            </div>
            {taskElements}
        </div>
    );
}

export default PrintResults;